import { render } from "./ExportarEspecies.vue?vue&type=template&id=632bd092"
import script from "./ExportarEspecies.vue?vue&type=script&lang=js"
export * from "./ExportarEspecies.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/salvando-arvores-front/salvando-arvores-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__